import {z} from 'zod';

export const LeadSchema = z.object({
  name: z.string(),
  surname: z.string(),
  company: z.string(),
  role: z.string(),
  email: z.string().email(),
  phone: z.string(),
  termsAndConditions: z.literal<boolean>(true),
});

export type PostLead = z.infer<typeof LeadSchema>;

export const QuotationRequestSchema = z.object({
  name: z.string(),
  surname: z.string(),
  company: z.string(),
  role: z.string(),
  email: z.string().email(),
  phone: z.string(),
  users: z.string(),
  termsAndConditions: z.literal<boolean>(true),
});

export type QuotationRequest = z.infer<typeof QuotationRequestSchema>;

export const QuotationNoCompanyRequestSchema = z.object({
  name: z.string(),
  surname: z.string(),
  email: z.string().email(),
  phone: z.string(),
  users: z.string(),
  termsAndConditions: z.literal<boolean>(true),
});

export type QuotationNoCompanyRequest = z.infer<
  typeof QuotationNoCompanyRequestSchema
>;
